<template>
    <div class=" admin_panel">
        <panel-ms>
            <h3>Авторизация</h3>
            <div class="ms___panel_input">
                <input class="ms__input" v-model="login" type="login" placeholder="Имя пользователя">
            </div>
            <div class="ms___panel_input">
                <input class="ms__input" v-model="password" type="password" placeholder="Пароль">
            </div>
            <button-ms @click="setSession">Войти</button-ms>
        </panel-ms>
    </div>
</template>

<script>
import buttonMs from '@/components/common/buttonMs.vue';
import panelMs from '../components/common/panelMs.vue';  
import axios from 'axios';
  
export default{
    components:{
        buttonMs,
        panelMs
    },
    mounted(){
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.$router.push({path:'/'})
                }
            })
    },
    methods:{
        setSession(){
            axios
                .post("https://mosp51.ru/api/login", { "login": this.login, "password" : this.password})
                .then(response=>{
                    if (response.data.username){
                        this.$router.push({path:'/'})
                    }
                }).catch((error)=>{
                    console.log(error)
                })


        }
    },
    data(){
        return{
            login:'',
            password:'',
        }
    }
}
</script>
<style>
    .admin_panel{
        height: calc(100vh - 570px);
        margin-top: 205px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .admin_panel .search-ms__panel_button,
    .admin_panel .search-ms__button{
        width: 100%;
    }
    .admin_panel .panel{
        padding: 32px;
        display: flex;
        flex-direction: column;
        gap:24px;
    }

    .ms___panel_input{
        height: 42px;
        width: 333px;
        position: relative;
    }
    .ms__input{
        font-family: Rubik,sans-serif;
        font-size: 14px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 68px;
        background-color:#EDF6FF;
        border:1px solid #EDF6FF;
        border-radius: 10px;
        position: relative;
    }
    .ms__input::placeholder{
        font-size: 14px;
        letter-spacing: 0.02em;
    }
    .ms__input:focus{
        outline: none;
        border-color: #007BB8 ;
    }
    .ms__input:focus::placeholder{
        font-size: 14px;
        letter-spacing: 0.02em;
        
    }
</style>